import scrollMonitor from 'scrollmonitor'
import { requestTimeout } from '../util'

const $getStarted = $('section.get-started')
const $grid = $('.advantages-grid')
const $technology = $('.home-technology__content')

const setupScroll = () => {
  const getStartedWatcher = scrollMonitor.create($getStarted.get(0), $getStarted.height())
  const gridWatcher = scrollMonitor.create($grid.get(0), $grid.height() / 4)
  const technologyWatcher = scrollMonitor.create($technology.get(0), $technology.height())

  getStartedWatcher.fullyEnterViewport(() => {
    $getStarted.find('.get-started__icons li').each((index, el) => {
      const delay = 200 * (index + 1)

      requestTimeout(() => {
        $(el).addClass('item--active')
      }, delay)
    })

    getStartedWatcher.destroy()
  })

  gridWatcher.fullyEnterViewport(() => {
    $grid.find('.grid__cell--hidden').sort(() => (Math.round(Math.random()) - 0.5)).each((index, el) => {
      const delay = 200 * index

      requestTimeout(() => {
        $(el).removeClass('grid__cell--hidden')
      }, delay)
    })

    gridWatcher.destroy()
  })

  technologyWatcher.fullyEnterViewport(() => {
    $technology.find('li').each((index, el) => {
      const delay = 200 * (index + 1)

      requestTimeout(() => {
        $(el).addClass('item--active')
      }, delay)
    })

    technologyWatcher.destroy()
  })
}

export default {
  can: () => $('body').hasClass('page-home'),
  run: () => {
    setupScroll()
  }
}
